import PropTypes from 'prop-types';
import { Fragment } from 'react';
import styled from 'styled-components';

import { colors } from '~/utils/css-mixins';

const NormalStart = styled.span`
  font-size: 14px;
  line-height: 20px;
`;

const ScratchedStart = styled(NormalStart)`
  color: ${colors.textmeta};
  text-decoration: line-through;
`;

const Horse = styled.span`
  font-weight: 600;
`;

const Start = ({ start, betType, leg }) => {
  const text = (
    <Horse>
      {[start.start_number, start.horse_name].filter(Boolean).join(' ')}
    </Horse>
  );

  const betTypeLeg = (
    <Fragment>
      ({betType}-{leg})
    </Fragment>
  );

  return start.scratched ? (
    <ScratchedStart>
      {text} {betTypeLeg}
    </ScratchedStart>
  ) : (
    <NormalStart>
      {text} {betTypeLeg}
    </NormalStart>
  );
};

Start.propTypes = {
  start: PropTypes.shape({
    start_number: PropTypes.number.isRequired,
    horse_name: PropTypes.string.isRequired,
    scratched: PropTypes.bool.isRequired,
  }).isRequired,
  betType: PropTypes.string,
  leg: PropTypes.number,
};

export default Start;
